module.exports = __webpack_public_path__ + "static/media/expiiHomepage.4e62dfae.jpg";